import { DataExport } from 'model/dataExports';

export interface DataExportsState {
    status: DataExportsStatus;
    loading: boolean;
    creating: boolean;
    error?: string;
    dataExports: Array<DataExport>;
}

export enum DataExportsStatus {
    // eslint-disable-next-line no-unused-vars
    Initial,
    // eslint-disable-next-line no-unused-vars
    Error,
    // eslint-disable-next-line no-unused-vars
    Fetching,
    // eslint-disable-next-line no-unused-vars
    FetchSuccess,
    // eslint-disable-next-line no-unused-vars
    Creating,
    // eslint-disable-next-line no-unused-vars
    CreateSuccess
}
